import { c as _c } from "react/compiler-runtime";
import { StrikeWeightLevel } from '@/lib/piano/touch-design/hammer-weight-level';
import type { KeyboardLike, KeyWith } from '@/lib/piano/keyboard';
import { useMemo } from 'react';
import { useDefaultSerie } from './use-default-serie';
import { useStrikeWeightCurve } from '@/hooks/standard-curves/use-strike-weight-curve';
export const useStrikeWeightStandardSeries = (keyboard, levels) => {
  const $ = _c(6);
  const {
    getStrikeWeightCurve
  } = useStrikeWeightCurve(keyboard);
  let t0;
  if ($[0] !== getStrikeWeightCurve || $[1] !== levels) {
    let t1;
    if ($[3] !== getStrikeWeightCurve) {
      t1 = level => [level, getStrikeWeightCurve(level)];
      $[3] = getStrikeWeightCurve;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    const entries = levels.map(t1);
    t0 = Object.fromEntries(entries);
    $[0] = getStrikeWeightCurve;
    $[1] = levels;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const strikeWeightLevelSmoothedSeries = t0 as Record<StrikeWeightLevel, number[]>;
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [StrikeWeightLevel.Level1, StrikeWeightLevel.Level5, StrikeWeightLevel.Level9, StrikeWeightLevel.Level13];
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const seriesWithBoldVariant = t1;
  const defaultSeries = useDefaultSerie(keyboard, levels, seriesWithBoldVariant, strikeWeightLevelSmoothedSeries);
  return defaultSeries;
};